import {
    DASHBOARD_PAGE_NEXT,
    DASHBOARD_PAGE_PREV,
    DASHBOARD_PAGE_SET_DATA,
    DASHBOARD_RESET,
    DASHBOARD_VEHICLE_REMOVE,
    DASHBOARD_JOB_REMOVE,
    DASHBOARD_AGENCY_REMOVE,
    DASHBOARD_GALLERY_REMOVE,
    DASHBOARD_ALARM_REMOVE
} from '../actions/constants'

const defaultState = {
    page: 1,
    page_size: 10,
    total: 0,
    items: []
};

export default (state = defaultState, action) => {
    switch (action.type){
        case DASHBOARD_PAGE_NEXT:
            return {
                ...state,
                page: state.page + 1
            }
        case DASHBOARD_PAGE_PREV:
            return {
                ...state,
                page: state.page - 1
            }
        case DASHBOARD_PAGE_SET_DATA:
            return {
                ...state,
                items: action.payload.results,
                total: action.payload.count
            }
        case DASHBOARD_RESET:
            return {
                ...defaultState
            }
        case DASHBOARD_VEHICLE_REMOVE:
            return {
                ...state,
                items: state.items.filter((el) => !(el.identifier === 'vehicle' && el.id === action.payload.id))
            }
        case DASHBOARD_JOB_REMOVE:
            return {
                ...state,
                items: state.items.filter((el) => !(el.identifier === 'job' && el.id === action.payload.id))
            }
        case DASHBOARD_AGENCY_REMOVE:
            return {
                ...state,
                items: state.items.filter((el) => !(el.identifier === 'agency' && el.id === action.payload.id))
            }
        case DASHBOARD_GALLERY_REMOVE:
            return {
                ...state,
                items: state.items.filter((el) => !(el.identifier === 'autogallery' && el.id === action.payload.id))
            }
        case DASHBOARD_ALARM_REMOVE:
            return {
                ...state,
                items: state.items.filter((el) => !(el.id === action.payload.id))
            }
        default:
            return state;
    }
};